// extracted by mini-css-extract-plugin
export default {"filesList":"FilesList_filesList__lO8J+","itemData":"FilesList_itemData__aXYgI","fa":"FilesList_fa__C7wFg"};